import { useState } from "react";
import Icon from "../../../components/Icon";
import { initials, fromNow } from "../../../utils/formatters";
import dayjs from "dayjs";

export function isOnline(lastActiveAt) {
  if (!lastActiveAt) return false;
  return dayjs().diff(dayjs(lastActiveAt), "minute") < 2;
}

export default function ConversationList({ conversations, activeId, currentUserId, onSelect, onNewChat }) {
  const [q, setQ] = useState("");
  const needle = q.trim().toLowerCase();
  const shown = needle
    ? conversations.filter((c) => (c.title || "").toLowerCase().includes(needle))
    : conversations;

  return (
    <div className="chat-sidebar">
      <div className="chat-sidebar-head">
        <span className="chat-sidebar-title">Chat</span>
        <div className="chat-search">
          <Icon name="search" size={13} />
          <input
            className="chat-search-input"
            placeholder="Search…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          {q && (
            <button type="button" className="chat-search-clear" onClick={() => setQ("")} title="Clear">
              <Icon name="x" size={12} />
            </button>
          )}
        </div>
        <button type="button" className="btn btn-secondary btn-sm chat-new-btn" onClick={onNewChat} title="New chat">
          <Icon name="plus" size={13} /> New
        </button>
      </div>

      <div className="chat-conv-list">
        {shown.length === 0 && (
          <div className="chat-conv-empty">{needle ? "No matches." : "No conversations yet."}</div>
        )}
        {shown.map((c) => {
          const channel = c.type === "channel";
          const online = !channel && isOnline(c.peer?.last_active_at);
          const last = c.last_message;
          const preview = last
            ? (last.deleted ? "message removed"
              : (last.sender_id === currentUserId ? "You: " : "") + (last.body || last.attachment_label || ""))
            : "No messages yet";

          return (
            <button
              key={c.id}
              type="button"
              className={`chat-conv ${c.id === activeId ? "active" : ""} ${c.unread > 0 ? "unread" : ""}`}
              onClick={() => onSelect(c)}
            >
              <div className="chat-conv-avatar">
                <div className={`avatar ${channel ? "avatar-channel" : ""}`}>
                  {channel ? <Icon name="users" size={16} /> : initials(c.title)}
                </div>
                {online && <span className="chat-online-dot" />}
              </div>

              <div className="chat-conv-main">
                <div className="chat-conv-top">
                  <span className="chat-conv-name">{channel ? (c.title || "Team channel") : c.title}</span>
                  {last && <span className="chat-conv-time">{fromNow(last.created_at)}</span>}
                </div>
                <div className="chat-conv-bottom">
                  <span className="chat-conv-preview">{preview}</span>
                  <span className="chat-conv-badges">
                    {c.muted && <Icon name="bell" size={11} />}
                    {c.unread > 0 && <span className="chat-unread-pill">{c.unread > 99 ? "99+" : c.unread}</span>}
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
